import { useRef, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { deviceRestockingCheckErrorSelector } from '@hero/redux-data/backoffice/deviceRestockingCheck/selectors';
import { useNotifications } from '../../context/notification';
const useDeviceRestockingCheckFailAlert = () => {
    const { error } = useSelector(deviceRestockingCheckErrorSelector, shallowEqual);
    const { addNotification, removeNotification } = useNotifications();
    const id = useRef();
    useEffect(() => {
        id.current && removeNotification(id.current);
        if (error) {
            id.current = addNotification({
                type: 'fail',
                message: 'Error running restocking check - most likely invalid device serial.'
            });
        }
        else {
            id.current = undefined;
        }
    }, [addNotification, removeNotification, error]);
};
export default useDeviceRestockingCheckFailAlert;
